// extracted by mini-css-extract-plugin
export default {"container":"ticketError__container__YzBM4","message":"ticketError__message__rF_9h","btn":"ticketError__btn__fpALC"};